import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca4f7588"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-avaliacoes" }
const _hoisted_2 = { class: "container-site" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"cabecalho-avaliacoes\" data-v-ca4f7588><div class=\"titulos-avaliacoes\" data-v-ca4f7588><span class=\"rotulo-secao\" data-v-ca4f7588> Avaliações </span><h2 class=\"titulo-secao\" data-v-ca4f7588> O que dizem os clientes. </h2></div><a class=\"link-google\" href=\"https://www.google.com/maps/search/?api=1&amp;query=LimaTec+Bonito+MS\" target=\"_blank\" rel=\"noopener\" data-v-ca4f7588><svg viewBox=\"0 0 24 24\" width=\"20\" height=\"20\" aria-hidden=\"true\" data-v-ca4f7588><path fill=\"#4285F4\" d=\"M23.5 12.27c0-.85-.08-1.66-.22-2.45H12v4.64h6.45a5.52 5.52 0 0 1-2.39 3.62v3h3.87c2.26-2.09 3.57-5.16 3.57-8.81z\" data-v-ca4f7588></path><path fill=\"#34A853\" d=\"M12 24c3.24 0 5.95-1.07 7.93-2.91l-3.87-3a7.25 7.25 0 0 1-10.8-3.81H1.27v3.1A12 12 0 0 0 12 24z\" data-v-ca4f7588></path><path fill=\"#FBBC05\" d=\"M5.26 14.28a7.2 7.2 0 0 1 0-4.56v-3.1H1.27a12 12 0 0 0 0 10.76l3.99-3.1z\" data-v-ca4f7588></path><path fill=\"#EA4335\" d=\"M12 4.75c1.77 0 3.35.61 4.6 1.8l3.43-3.43A11.97 11.97 0 0 0 1.27 6.62l3.99 3.1A7.2 7.2 0 0 1 12 4.75z\" data-v-ca4f7588></path></svg> Ver avaliações no Google </a></div>", 1)
const _hoisted_4 = { class: "grade-avaliacoes" }
const _hoisted_5 = {
  class: "estrelas",
  "aria-label": "5 de 5 estrelas"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M12 2l2.9 6.26 6.6.7-4.95 4.5 1.4 6.54L12 16.77 6.05 20l1.4-6.54L2.5 8.96l6.6-.7z" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "texto-avaliacao" }
const _hoisted_9 = { class: "autor-avaliacao" }
const _hoisted_10 = { class: "inicial-autor" }
const _hoisted_11 = { class: "dados-autor" }
const _hoisted_12 = { class: "nome-autor" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "origem-autor" }, " Avaliação no Google ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.avaliacoes, (avaliacao) => {
          return (_openBlock(), _createElementBlock("article", {
            class: "cartao-avaliacao",
            key: avaliacao.nome
          }, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                return _createElementVNode("svg", {
                  key: n,
                  viewBox: "0 0 24 24",
                  width: "18",
                  height: "18",
                  fill: "#FBBC05",
                  "aria-hidden": "true"
                }, _hoisted_7)
              }), 64))
            ]),
            _createElementVNode("p", _hoisted_8, _toDisplayString(avaliacao.texto), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(avaliacao.nome.charAt(0)), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(avaliacao.nome), 1),
                _hoisted_13
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}